import { useBreakpointValue, useColorModeValue } from '@chakra-ui/react'

export const useCryptoTickerStyles = () => {
  const gridTemplateColumns = useBreakpointValue({
    base: 1,
    sm: 2,
    md: 3,
    lg: 4
  }) as number | undefined

  const cardBg = useColorModeValue('white', 'gray.800')
  const statCardBg = useColorModeValue('gray.50', 'gray.700')
  const borderColor = useColorModeValue('gray.200', 'gray.600')
  const accentColor = 'synthwave.400'

  return {
    gridTemplateColumns,
    cardBg,
    statCardBg,
    borderColor,
    accentColor
  }
}

export const descriptionStyles = {
  linkStyles: {
    color: 'synthwave.400'
  },
  paragraphStyles: {
    mb: 4
  }
}
